import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';



// import React, { useState } from 'react';
import axios from 'axios';
import { loadStripe } from '@stripe/stripe-js';
import './PaymentForm.css';
import { useLocation ,useSearchParams} from 'react-router-dom';

const StripeIntegrationPage = () => {

    // const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    // const location = useLocation();
    // const token = localStorage.getItem('authToken');

  
    // const navigate = useNavigate();
    // const [searchParams] = useSearchParams();
    const [verifying, setVerifying] = useState(true);
    const [paymentDetails, setPaymentDetails] = useState(null);
    const [error, setError] = useState(null);
//  const serverUrl = 'http://localhost:5000'; 
  // const serverUrl = 'http://192.168.10.167:8000';
  // const serverUrl = 'https://flowmap.uvjtech.in';
  
  // const serverUrl = "https://4ad0e8a691b5.ngrok-free.app";
//  const serverUrl = 'http://localhost:5000';
  const serverUrl = 'https://beta.flowlogic.com';


    const location = useLocation();

  const navigate = useNavigate();
  const [plans, setPlans] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isYearly, setIsYearly] = useState(true);
  const token = localStorage.getItem('authToken');
// const stripePromise = loadStripe('pk_test_51Rq76fC5GKbLs6Mr7iQHl54rJYZp3Vz23CnFaBH1EodYvSb10oFyaPnWz3pz9xy60wfiSu0s4S5iEqWxn3s3SF8q00YXARdHV9'); // ✅ Replace with your Stripe publishable key
const stripePromise = loadStripe('pk_test_51PWb51CNmy7Ziw7S30NOpJQSmy1y4hfb8ROv7aO99QgglVeTPLbdIrLx2RPWgdu52WKyOgMfcxgEEZ6ZpNbOnpim00hn8gRSwX'); // ✅ Replace with your Stripe publishable key
  // 🔹 1. Fetch subscription plans on page load

  const features = [
  "Advanced Investment Insights",
  "Ranking Boost",
  "Crime & Catastrophe Index",
  "Cost of Living Analysis",
  "Included in Client Recommendations",
  "12 Months Access"
];

  // // Toggle logic
  // const handleToggle = () => {
  //   const planType = isYearly ? 'Monthly' : 'Yearly';
  //   const plan = plans.find(p => p.plan_type === planType);
  //   if (plan) setSelectedPlan(plan);
  //   setIsYearly(!isYearly);
  // };
  const handleToggle = () => {
  const newType = isYearly ? 'monthly' : 'yearly';
  const plan = plans.find(p => p.plan_type.toLowerCase() === newType);
  if (plan) {
    setSelectedPlan(plan); // ✅ Selected plan is now directly from backend response
    setIsYearly(!isYearly);
  }
};
  useEffect(() => {
    const fetchPlans = async () => {
      try {
        // const response = await fetch('https://beta.flowlogic.com/api/subscriptions/plans/', {
        const response = await fetch(`${serverUrl}/api/subscriptions/plans/`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        if (!response.ok) {
          throw new Error('Failed to fetch plans');
        }

        const data = await response.json();
        setPlans(data);

              const yearlyPlan = data.find(p => p.plan_type.toLowerCase() === 'yearly');
      if (yearlyPlan) {
        setSelectedPlan(yearlyPlan);
        setIsYearly(true);
      }
      } catch (error) {
        console.error('Error fetching plans:', error);
      }
    };

    fetchPlans();
  }, [token]);




  const handlePayment = async () => {
  if (!selectedPlan) {
    alert('Please select a plan');
    return;
  }

  setLoading(true);
  setMessage('');

  try {
    const stripe = await stripePromise;


    const response = await axios.post(
      // `${serverUrl}/api/subscriptions/create-intent/`,
      `${serverUrl}/api/subscriptions/checkout-session/`,
      // `${serverUrl}/create-checkout-session/`,
      // `https://beta.flowlogic.com/api/subscriptions/checkout-session/`,
      {
        amount: parseFloat(selectedPlan.price) * 100, // Convert to cents
        description: selectedPlan.name + ' - ' + selectedPlan.plan_type,
        plan_id: selectedPlan.id,
        // plan_id: 2,
        // success_url: `${window.location.origin}/payment-success1`,
        // cancel_url: `${window.location.origin}/payment-failure`,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );

    const sessionId = response.data.sessionId || response.data.id; // ⚠️ Use correct field from backend

    if (!sessionId) {
      setMessage('Failed to create checkout session.');
      setLoading(false);
      return;
    }

    const result = await stripe.redirectToCheckout({ sessionId });

    if (result.error) {
      setMessage(result.error.message);
    }
  } catch (error) {
    console.error(error);
    setMessage('Something went wrong. Try again.');
  }

  setLoading(false);
};


  
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'flex-start',
      gap: '60px',
      padding: '50px 0'
    }}>
      {/* Left Section */}
      <div style={{ flex: 1, maxWidth: '480px' }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '24px' }}>
          {/* <img src="pro-logo.png" alt="Pro" style={{ width: 40, marginRight: 16 }} /> */}
        </div>
        <h1 style={{ fontSize: '2rem', fontWeight: 700 }}>Get deeper ZIP-level insights —  ROI & appreciation</h1>
        <p style={{ fontSize: '1.3rem', color: '#444', marginTop: '16px' }}>
          
           crime & catastrophic risk indexes, cost-of-living analysis, exportable reports, and priority placement in the marketplace.
          
        </p>
      </div>
      {/* Right Section */}
      <div style={{
        flex: 1,
        maxWidth: '380px',
        background: 'rgba(248,249,255,0.95)',
        borderRadius: '22px',
        padding: '38px 36px',
        boxShadow: '0 2px 14px rgba(30,34,64,0.08)'
      }}>
        <div style={{
          fontSize: '2.3rem',
          fontWeight: 700,
          marginBottom: 6
        }}>
          ${selectedPlan?.price || '--'} <span style={{ fontSize: '1rem', fontWeight: 400 }}>
            per month, billed {isYearly ? 'yearly' : 'monthly'}
          </span>
        </div>
        {/* Toggle */}
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '18px' }}>
          <span style={{
            fontWeight: isYearly ? 700 : 500, color: isYearly ? '#1c8f7d' : '#888', cursor: 'pointer'
          }} onClick={() => { if (!isYearly) handleToggle(); }}>Yearly</span>
          <div
            style={{
              width: 44, height: 24, background: '#e0e0ed',
              borderRadius: 14, margin: '0 10px', position: 'relative', cursor: 'pointer'
            }}
            onClick={handleToggle}
          >
            <div style={{
              width: 20, height: 20, borderRadius: '50%', background: '#1c8f7d', position: 'absolute',
              top: 2, left: isYearly ? 22 : 2, transition: 'left 0.2s'
            }} />
          </div>
          <span style={{
            fontWeight: !isYearly ? 700 : 500, color: !isYearly ? '#1c8f7d' : '#888', cursor: 'pointer'
          }} onClick={() => { if (isYearly) handleToggle(); }}>Monthly</span>
          <span style={{ color: '#f65158', fontWeight: 600, fontSize: '1rem', marginLeft: 8 }}>
            {isYearly ? 'YOU SAVE 50%' : ''}
          </span>
        </div>
        {/* Features */}
        <ul style={{ padding: '0 0 14px 0' }}>
          {features.map((feature, idx) => (
            <li key={idx}
                style={{
                  marginBottom: '10px',
                  fontSize: '1.08rem',
                  listStyle: 'none',
                  position: 'relative',
                  paddingLeft: 24
                }}>
              <span style={{
                position: 'absolute',
                left: 0,
                top: 6,
                width: 14,
                height: 14,
                background: '#1c8f7d',
                borderRadius: '50%',
                display: 'inline-block'
              }} />
              <span style={{ marginLeft: 4 }}>{feature}</span>
            </li>
          ))}
        </ul>
        {/* Join Button */}
        <button
          onClick={handlePayment}
          disabled={loading}
          style={{
            display: 'block',
            width: '100%',
            padding: '14px',
            fontSize: '1.15rem',
            backgroundColor: '#1c8f7d',
            color: '#fff',
            border: 'none',
            borderRadius: '10px',
            cursor: loading ? 'not-allowed' : 'pointer',
            fontWeight: 600
          }}
        >
          {loading ? 'Processing...' : 'Join Pro'}
        </button>
      </div>
    </div>
  );


};

export default StripeIntegrationPage;



